import { render } from "preact";
import "./styles/main.css";
import { App } from "@/editor/App";

const root = document.getElementById("app");
if (root) {
  render(<App />, root);
}
